import React, { useEffect } from 'react';
import {
	Box,
	Typography,
	useTheme,
	useMediaQuery,
	styled
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useHeader } from 'context/HeaderContext';

const StyledBox = styled(Box)({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	backgroundColor: '#fff',
	borderBottom: '1px solid #e0e0e0',
	marginBottom: 32,
	padding: 8
});

const Subheader = ({ title, buttons, ...props }) => {
	const theme = useTheme();
	const path = useLocation();
	const { updateHeaderProps } = useHeader();

	useEffect(() => {
		// Only update if the values have actually changed
		if (title || buttons) {
			updateHeaderProps({ title, buttons });
		}
	}, [title, buttons]); // Remove updateHeaderProps from dependencies since it's now memoized

	// Don't render the Subheader at all since the info is in the Header
	return null;
};

export default Subheader;
